import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FaTruck, FaCheckCircle, FaTimesCircle, FaMoneyBill, FaUsers } from "react-icons/fa";
import { HiOutlineArrowTrendingUp, HiOutlineArrowTrendingDown } from "react-icons/hi2";

const OverviewBox = ({ viewMode, setViewMode, currentData, calculateGrowth }) => {
  console.log(currentData);
  return (
    <div>
      {!currentData ? (
        <div>Loading...</div>
      ) : (
        <div className="small-dashboard box-container shadow-sm p-3 bg-white border-0 rounded">
          <div className="custom-box-header">
            <h5 className="box-title text-primary mb-4">Tổng quan chuyến xe</h5>
            {/* Select thay cho nút chọn chế độ hiển thị */}
            <div className="view-mode-selector mb-3">
              <select
                className="form-select"
                value={viewMode}
                onChange={(e) => setViewMode(e.target.value)}
              >
                <option value="day">Ngày</option>
                <option value="week">Tuần</option>
                <option value="month">Tháng</option>
              </select>
            </div>
          </div>
          <Row className="g-3">
            {/* Tổng chuyến */}
            <Col>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="d-flex align-items-center">
                  <FaTruck size={24} className="text-primary me-3" />
                  <div>
                    <h6 className="text-muted mb-1">Tổng chuyến</h6>
                    <h5>{currentData?.totalTrips.toLocaleString()}</h5>
                    <div
                      className={
                        calculateGrowth(currentData?.totalTrips, currentData?.totalTripsPrev) > 0
                          ? "text-success"
                          : "text-danger"
                      }
                    >
                      {calculateGrowth(currentData?.totalTrips, currentData?.totalTripsPrev) > 0 ? (
                        <HiOutlineArrowTrendingUp />
                      ) : (
                        <HiOutlineArrowTrendingDown />
                      )}{" "}
                      {calculateGrowth(currentData?.totalTrips, currentData?.totalTripsPrev)}%
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Chuyến hoàn thành */}
            <Col>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="d-flex align-items-center">
                  <FaCheckCircle size={24} className="text-success me-3" />
                  <div>
                    <h6 className="text-muted mb-1">Chuyến hoàn thành</h6>
                    <h5>{currentData?.completedTrips.toLocaleString()}</h5>
                    <div
                      className={
                        calculateGrowth(currentData?.completedTrips, currentData?.completedTripsPrev) > 0
                          ? "text-success"
                          : "text-danger"
                      }
                    >
                      {calculateGrowth(currentData?.completedTrips, currentData?.completedTripsPrev) > 0 ? (
                        <HiOutlineArrowTrendingUp />
                      ) : (
                        <HiOutlineArrowTrendingDown />
                      )}{" "}
                      {calculateGrowth(currentData?.completedTrips, currentData?.completedTripsPrev)}%
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Chuyến chưa hoàn thành */}
            <Col>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="d-flex align-items-center">
                  <FaTimesCircle size={24} className="text-danger me-3" />
                  <div>
                    <h6 className="text-muted mb-1">Chuyến chưa hoàn thành</h6>
                    <h5>{currentData?.incompleteTrips.toLocaleString()}</h5>
                    <div
                      className={
                        calculateGrowth(currentData?.incompleteTrips, currentData?.incompleteTripsPrev) > 0
                          ? "text-danger"
                          : "text-success"
                      }
                    >
                      {calculateGrowth(currentData?.incompleteTrips, currentData?.incompleteTripsPrev) > 0 ? (
                        <HiOutlineArrowTrendingUp />
                      ) : (
                        <HiOutlineArrowTrendingDown />
                      )}{" "}
                      {calculateGrowth(currentData?.incompleteTrips, currentData?.incompleteTripsPrev)}%
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Tổng doanh thu */}
<Col>
  <Card className="shadow-sm border-0 h-100">
    <Card.Body className="d-flex align-items-center">
      <FaMoneyBill size={24} className="text-warning me-3" />
      <div>
        <h6 className="text-muted mb-1">Tổng doanh thu</h6>
        <h5>
          {new Intl.NumberFormat("vi-VN", { style: "decimal", useGrouping: true }).format(
            currentData?.totalRevenue || 0
          )}{" "}
          ₫
        </h5>
        <div
          className={
            calculateGrowth(currentData?.totalRevenue, currentData?.totalRevenuePrev) > 0
              ? "text-success"
              : "text-danger"
          }
        >
          {calculateGrowth(currentData?.totalRevenue, currentData?.totalRevenuePrev) > 0 ? (
            <HiOutlineArrowTrendingUp />
          ) : (
            <HiOutlineArrowTrendingDown />
          )}{" "}
          {calculateGrowth(currentData?.totalRevenue, currentData?.totalRevenuePrev).toLocaleString("vi-VN")}%
        </div>
      </div>
    </Card.Body>
  </Card>
</Col>

            {/* Tổng khách hàng */}
            <Col>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="d-flex align-items-center">
                  <FaUsers size={24} className="text-info me-3" />
                  <div>
                    <h6 className="text-muted mb-1">Tổng khách hàng</h6>
                    <h5>{currentData?.totalCustomers.toLocaleString()}</h5>
                    <div
                      className={
                        calculateGrowth(currentData?.totalCustomers, currentData?.totalCustomersPrev) > 0
                          ? "text-success"
                          : "text-danger"
                      }
                    >
                      {calculateGrowth(currentData?.totalCustomers, currentData?.totalCustomersPrev) > 0 ? (
                        <HiOutlineArrowTrendingUp />
                      ) : (
                        <HiOutlineArrowTrendingDown />
                      )}{" "}
                      {calculateGrowth(currentData?.totalCustomers, currentData?.totalCustomersPrev)}%
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>)}
    </div>
  );
};

export default OverviewBox;
